import type { IconData } from '@stacksjs/iconify-core'

export const natureMoon: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 16a8 8 0 0 0 7.648-10.356A4 4 0 1 1 10.356.352A8 8 0 1 0 8 16\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default natureMoon
